import { useEffect } from 'react'

import { useSession } from '../features/auth/useSession'

/**
 * Título de la pestaña, con el nombre del estudio.
 *
 * Ninguna pantalla del panel lo fijaba, así que todas heredaban el de
 * `index.html` —«ChasquiTambo · Entrega de fotos y vídeo para estudios»— y el
 * fotógrafo veía nuestra marca en su pestaña, en su dominio, mientras
 * trabajaba. En un producto que vende «con tu nombre» la pestaña también
 * cuenta: es lo que se lee con quince pestañas abiertas.
 *
 * El portal del cliente final no usa esto: allí el título lo pone
 * `GalleryPage` con el nombre del proyecto, que es más útil que el de la
 * sección.
 */
export function usePageTitle(title: string): void {
  const studio = useSession((state) => state.tenant?.name)

  useEffect(() => {
    document.title = studio === undefined ? `${title} · ChasquiTambo` : `${title} · ${studio}`
  }, [title, studio])
}
